import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Typography
} from '@material-ui/core'
import { useState } from 'react'

import toastError from '../../errors/toastError'
import api from '../../services/api'
import { i18n } from '../../translate/i18n'
import { ButtonPrimary } from '../ButtonPrimary'
import { ButtonSecondary } from '../ButtonSecondary'
import SelectInput from '../SelectInput'
import { useStyles } from './style'

const TransferWhenClosingModal = ({
  open,
  onClose,
  onConfirmTransfer,
  onConfirmClose,
  ticket,
  linkedAttendants
}) => {
  const classes = useStyles()
  const [selectedAttendantId, setSelectedAttendantId] = useState('')
  const [loading, setLoading] = useState(false)

  const handleClose = () => {
    setSelectedAttendantId('')
    setLoading(false)
    onClose()
  }

  const handleTransfer = async () => {
    if (!selectedAttendantId) {
      toastError({ response: { data: { message: 'Selecione um atendente' } } })
      return
    }

    setLoading(true)
    try {
      const { data } = await api.post(
        `/tickets/${ticket.id}/transfer-to-attendant`,
        {
          newUserId: Number(selectedAttendantId)
        }
      )

      if (onConfirmTransfer) {
        onConfirmTransfer(data.ticket)
      }
      handleClose()
    } catch (err) {
      setLoading(false)
      toastError(err)
    }
  }

  const handleCloseTicket = async () => {
    setLoading(true)
    try {
      if (onConfirmClose) {
        await onConfirmClose()
      }
      setLoading(false)
      handleClose()
    } catch (err) {
      setLoading(false)
      toastError(err)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      scroll="paper"
    >
      <DialogTitle className={classes.dialogTitle}>
        {i18n.t('transferWhenClosingModal.title')}
      </DialogTitle>
      <DialogContent dividers>
        <div className={classes.container}>
          <Typography variant="body2" className={classes.message}>
            {i18n.t('transferWhenClosingModal.message')}
          </Typography>

          <SelectInput
            label={i18n.t('transferWhenClosingModal.selectAttendant')}
            labelId="transfer-when-closing-attendant-select-label"
            id="transfer-when-closing-attendant-select"
            value={selectedAttendantId}
            onChange={e => setSelectedAttendantId(e.target.value)}
            disabled={loading}
          >
            {linkedAttendants.map(attendant => (
              <MenuItem key={attendant.id} value={attendant.id}>
                {attendant.name}
              </MenuItem>
            ))}
          </SelectInput>
        </div>
      </DialogContent>
      <DialogActions>
        <ButtonSecondary
          onClick={handleClose}
          disabled={loading}
          label={i18n.t('transferWhenClosingModal.buttons.cancel')}
        />

        <ButtonPrimary
          label={i18n.t('transferWhenClosingModal.buttons.transfer')}
          loading={loading}
          onClick={handleTransfer}
          disabled={!selectedAttendantId}
        />
        <ButtonPrimary
          label={i18n.t('transferWhenClosingModal.buttons.close')}
          loading={loading}
          onClick={handleCloseTicket}
          variantColor="success"
        />
      </DialogActions>
    </Dialog>
  )
}

export default TransferWhenClosingModal
